// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__en1To","alertIcon":"ConfirmModal_alertIcon__ySdTp"};